import { Button, Col, Form, Row, Switch } from 'antd';
import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { CONSTANT } from '../../../../config/Constant';

const FormProvider: React.FC<any> = (props) => {
  const { form, handleAddProvider, dataEditModal } = props;
  const [activeProvider, setActiveProvider] = useState<boolean>(dataEditModal?.active ?? true);

  const handleBlockUser = (val: boolean) => {
    setActiveProvider(val);
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  // for Submit
  const handleSubmit = (data: any) => {
    const payload = {
      ...data,
      active: activeProvider,
    };
    handleAddProvider(payload);
  };
  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete="off"
      >
        <Row gutter={30}>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="provider_name"
              label="Provider Name"
              required
              rules={[validations.required.text('Provider Name')]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="provider_code"
              label="Provider Code"
              required
              rules={[validations.required.text('Provider Code')]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Text
              name="url"
              label="URL"
              required
              rules={[validations.required.text('URL')]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Number
              name="network_identity"
              label="Network Identity"
              required
              rules={[validations.required.text('Network Identity'), validations.pattern.numeric]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <InputBox.Select
              label="Network Type"
              name={'network_type'}
              placeholder="Select Network Type"
              tooltip={
                <>
                  For cellular number, the value must be <strong>M</strong>. <br />
                  For a fixed number (landline) the value must be <strong>F</strong>.
                </>
              }
              options={{
                list: CONSTANT.NETWORK_TYPE,
                valueKey: 'id',
                textKey: 'value',
              }}
              required
              rules={[validations.required.select('Network Type')]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
          >
            <Form.Item label="Active">
              <Switch
                value={activeProvider}
                onChange={(e: boolean) => {
                  handleBlockUser(e);
                }}
              />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
          >
            <Button
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormProvider;
